import React from "react";
import { FaCaretDown } from "react-icons/fa";
import Select, { components } from "react-select";

import { EMPTY_STRING, COLOR } from "../../../constants";
import { customStyles } from "./CustomStyles";

const ReactSelect = ({
  options,
  selectedOption,
  setSelectedOption,
  isMulti = false,
  name = EMPTY_STRING,
  placeholder = EMPTY_STRING,
  defaultStyle = true,
}) => {
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FaCaretDown color={defaultStyle ? COLOR.WHITE : COLOR.TEAL} />
      </components.DropdownIndicator>
    );
  };

  return (
    <>
      <Select
        name={name}
        isClearable={false}
        isMulti={isMulti}
        options={options}
        value={selectedOption}
        getOptionLabel={(x) => x.name}
        getOptionValue={(x) => x.id}
        onChange={setSelectedOption}
        styles={customStyles(defaultStyle)}
        placeholder={placeholder}
        components={{ DropdownIndicator }}
      />
    </>
  );
};

export default ReactSelect;
